import { render, staticRenderFns } from "./FormFooterActions.vue?vue&type=template&id=4d4cd275&scoped=true"
import script from "./FormFooterActions.vue?vue&type=script&lang=js"
export * from "./FormFooterActions.vue?vue&type=script&lang=js"
import style0 from "./FormFooterActions.vue?vue&type=style&index=0&id=4d4cd275&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4cd275",
  null
  
)

export default component.exports